import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Nutrition from './pages/Nutrition';
import AboutMe from './pages/AboutMe';
import Training from './pages/Training';
import Page404 from './pages/Page404';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/nutrition" element={<Nutrition />} />
          <Route exact path="/aboutme" element={<AboutMe />} />
          <Route exact path="/training" element={<Training />} />
          <Route path='*' element={<Page404 />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
